import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { cableId, type CableId } from './Cable.js'

/** Represents the view public.cable_events_view_ */
export default interface CableEventsViewTable {
  /** Database type: pg_catalog.int4 */
  cableId: ColumnType<CableId, never, never>

  /** Database type: pg_catalog.int4 */
  cableSerial: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.text */
  action: ColumnType<string, never, never>

  /** Database type: pg_catalog.text */
  notes: ColumnType<string | null, never, never>

  /** Database type: pg_catalog.text */
  operator: ColumnType<string | null, never, never>

  /** Database type: pg_catalog.timestamptz */
  eventDate: ColumnType<Date, never, never>

  /** Database type: pg_catalog.int4 */
  calibrationId: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.text */
  createdByUser: ColumnType<string, never, never>
}

export type CableEventsView = Selectable<CableEventsViewTable>

export const cableEventsView = z.object({
  cableId: cableId,
  cableSerial: z.number().nullable().optional(),
  action: z.string(),
  notes: z.string().nullable().optional(),
  operator: z.string().nullable().optional(),
  eventDate: z.coerce.date(),
  calibrationId: z.number().nullable().optional(),
  createdByUser: z.string(),
}) as unknown as z.Schema<CableEventsView>
